import {
  Dialog,
  DialogBackdrop,
  DialogPanel
} from "@headlessui/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFileDownload } from "@fortawesome/free-solid-svg-icons"

export default function Modal({
  image,
  image2,
  image3,
  open,
  setOpen,
}) {
  return (
    <Dialog open={open} onClose={setOpen} className="relative z-50">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-10 w-screen">
        <div className="flex h-full items-center justify-center">
          <DialogPanel
            transition
            className="relative transform overflow-y-scroll @apply [scrollbar-width:none] [&::-webkit-scrollbar]:hidden max-h-[90%] rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:w-full sm:max-w-4xl data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >

            <div className="sm:flex sm:items-start ">
              <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                <div className="mt-2 flex-col justify-center text-center">
                  <div className="sticky top-0 bg-white h-[60px] opacity-90">
                    <div
                      onClick={() => {
                      const link = document.createElement("a")
                      link.href = "/assets/saraWasimResume.pdf"
                      link.download = "saraWasimResume.pdf"
                      document.body.appendChild(link)
                      link.click()
                      document.body.removeChild(link)
                      }}
                      className={
                        "text-xs py-1.5 px-4 rounded transition ease-in bg-slate-200 text-slate-700 hover:bg-black hover:text-white font-roboto font-normal absolute right-[50px] top-[20px] animate-bounce flex cursor-pointer z-"
                      }
                      >
                      <FontAwesomeIcon
                        className="h-4 w-4  inline-block pr-2 align-center"
                        icon={faFileDownload}
                      />
                      <div>Download PDF</div>
                    </div>
                  </div>
                  <img src={image} alt="" className="-mt-8 -ml-2" />
                  <img src={image2} alt="" className="-mt-2 -ml-2 mb-8" />
                  <img src={image3} alt="" className="-mt-6 -ml-2 mb-8" />
                </div>
              </div>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  )
}
